
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/simplyhealth",
      function () {
        return require("private-next-pages/simplyhealth/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/simplyhealth"])
      });
    }
  